"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cardsDescription_1 = require("./cardsDescription");
const formatPercentage_1 = require("../formatPercentage");
let oldestDate = new Date().toISOString();
const desiredOrder = [
    '30 Year Fixed Conforming',
    '30 Year FHA',
    '30 Year VA',
    '20 Year Fixed Conforming',
    '15 Year Fixed Conforming',
    '25 Year FHA',
    '20 Year FHA',
    '10 Year Fixed Conforming',
    '30 Year Jumbo (Non Conforming)',
    '7/6 ARM Conforming',
];
const getFormattedValue = (value) => {
    const numberValue = Number(value);
    const formatted = (0, formatPercentage_1.formatPercentage)(numberValue, false);
    return formatted.replace('%', '');
};
const compareDate = (date) => {
    if (oldestDate > date)
        oldestDate = date;
};
const formatCurrency = (currencyString) => {
    const number = parseFloat(currencyString);
    if (isNaN(number))
        return 'N/A';
    return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};
const parseRatesData = (data) => {
    let parsedInformation = [];
    if (!data) {
        parsedInformation = desiredOrder.map((prodType) => {
            return {
                ...cardsDescription_1.baseCardDescription[prodType],
                rate: '0.000',
                apr: '0.000',
                monthlyPayment: '0.000',
                pointsPaid: '0.000',
                pointsPaidDollar: '0.000',
                date: oldestDate,
            };
        });
    }
    else {
        parsedInformation = desiredOrder.map((prodType) => {
            if (data && data[prodType]) {
                compareDate(data[prodType].datePriced);
                return {
                    ...data[prodType],
                    ...cardsDescription_1.baseCardDescription[prodType],
                    rate: getFormattedValue(data[prodType].rate),
                    apr: getFormattedValue(data[prodType].apr),
                    monthlyPayment: formatCurrency(data[prodType].monthlyPayment),
                    pointsPaid: getFormattedValue(data[prodType].pointsPaid),
                    pointsPaidDollar: formatCurrency(data[prodType].pointsPaidDollar),
                    date: data[prodType].datePriced,
                };
            }
        });
    }
    const cleanInformation = parsedInformation.filter(Boolean);
    const priorityList = [
        {
            id: 'most-popular',
            title: 'Most popular',
            data: cleanInformation.slice(0, 5),
        },
        {
            id: ' other-options',
            title: 'Other options',
            data: cleanInformation.slice(5),
        },
    ];
    return { parsedData: priorityList, lastUpdate: oldestDate };
};
exports.default = parseRatesData;
